export default "__VITE_ASSET__DMWEYJzG__"